<div
  #toastContainer
  class="mzic-popover style-toast medium {{ positionClass }} {{
    toastClass
  }} toast-dismissible">
  <div>
    @if (showSpinner) {
      <mzic-spinner class="toast-spinner" />
    } @else {
      <mzic-svg [src]="iconPath" [class]="iconClass" />
    }
    <div class="message-container">
      <div class="toast-message">
        {{ message }}
      </div>
    </div>
  </div>
</div>
